import { DEMO_PROJECT_ID, DEMO_TASK_ID } from '../constants';

/** 来自 GET /api/findings?task_id=... — claimflow测试2 的 11 条漏洞 */
export const demoFindingsList = [
  {
    id: 'd6b5b7b0-759c-4dcd-bb81-187329e70863',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - Underwriter makeDecision',
    category_name: 'idor',
    level: '',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: '',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1507',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:43:54.650235',
    updated_at: '2026-05-21T15:43:54.650235',
  },
  {
    id: 'ee75ada9-6b5e-4d14-bd90-823c5d23c53d',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - Underwriter Claim Detail Access',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1505',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:42:46.447056',
    updated_at: '2026-05-21T15:43:31.219515',
  },
  {
    id: '74c78245-d869-4b40-bf26-effbdee83c6c',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 文件上传无资源所有权校验',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1504',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:42:01.437473',
    updated_at: '2026-05-21T15:42:35.916056',
  },
  {
    id: '495ea665-c1ef-4b59-839e-e225f8ac6466',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - Claim Workflow Status Transition',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1502',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:40:49.572462',
    updated_at: '2026-05-21T15:41:45.549311',
  },
  {
    id: '0e01cc9a-a20e-4863-a7e4-dfd77f391933',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 理赔工作流数据泄露',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1501',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:39:03.035307',
    updated_at: '2026-05-21T15:40:38.430054',
  },
  {
    id: '8e6b22ae-08c2-4959-893c-3f7c1bf8d614',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - Claim Triage',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1499',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:37:38.206486',
    updated_at: '2026-05-21T15:38:50.241772',
  },
  {
    id: '0b8f2d21-639a-45f9-8553-ecb5a1a52bbd',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 欺诈检测API未校验claim归属',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1496',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:35:50.351949',
    updated_at: '2026-05-21T15:37:23.022423',
  },
  {
    id: '8ff4ace9-75ef-464b-b7db-1c13f8a2e004',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 理赔赔付金额越权修改',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1495',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:34:51.837364',
    updated_at: '2026-05-21T15:35:41.587415',
  },
  {
    id: '96c23d19-1d97-420f-954b-a62f8114a1e9',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 理赔赔付金额越权修改',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1494',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:34:07.886241',
    updated_at: '2026-05-21T15:34:38.574001',
  },
  {
    id: '62ae374e-69c6-4438-8911-5a84b2651219',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 赔付结算信息泄露',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1492',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:33:28.673158',
    updated_at: '2026-05-21T15:33:55.767227',
  },
  {
    id: '23f074e7-5393-4177-92c0-24f1e0bdc702',
    project_id: '756673a8-ad64-475e-84d1-8ffef7421931',
    task_id: 'b8b07d32-d7d5-4efa-8695-60d7e1250ff1',
    vul_name: 'IDOR - 理赔数据导出越权访问',
    category_name: 'idor',
    level: 'HIGH',
    verdict: 'LIKELY_VULNERABLE',
    verification_status: 'CONFIRMED',
    status: 'open',
    neo4j_element_id: '4:f2e67167-c5a5-4805-840e-94d6ba96963f:1490',
    confidence: 'HIGH',
    created_at: '2026-05-21T15:32:16.677549',
    updated_at: '2026-05-21T15:33:18.209867',
  },
] as const;
